// @flow

import React from 'react';
import logoSrc from './logo-inverse.png';

const ParkChicagoLogoInverse = () => (
  <img src={logoSrc} width="192" height="40" alt="ParkChicago Logo Inverse" />
);

export default ParkChicagoLogoInverse;



// WEBPACK FOOTER //
// ./src/assets/park-chicago-logo-inverse.js